import { Component, Inject, DOCUMENT } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { GoogleAnalyticsService } from './services/common/google-analytics.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  title = 'suppliers-portal-web';
  route: string = '';
  logged: boolean = false;
  token!: string | null;
  constructor(
    public router: Router,
    private googleAnalyticsService: GoogleAnalyticsService,
    // @Inject(DOCUMENT) private document: Document,
  ) {
    this.router.events.subscribe((events) => {
      if (events instanceof NavigationEnd) {
        this.route = router.url;
      }
    });
    this.googleAnalyticsService.setGoogleAnalytics();
  }
}
